import React from 'react'
import ModelContext from '../contexts/ModelContext'
import useParameterDecoder from './use-parameter-decoder'
import { autorun } from 'mobx'
import isEqual from 'lodash/isEqual'

export default function useParameters (inputParameters = {}) {
  const model = React.useContext(ModelContext)
  const decoder = useParameterDecoder()
  const [parameters, setParameters] = React.useState(decoder(inputParameters))

  const buildParameters = () => {
    const nextParameters = decoder(inputParameters)

    if (!isEqual(parameters, nextParameters)) {
      setParameters(nextParameters)
    }
  }

  React.useEffect(() => {
    const disposer = autorun(() => {
      buildParameters()
    }, { fireImmediately: true })

    return () => {
      disposer()
    }
  }, [model, inputParameters])

  return parameters
}
